import Store from '~/store'
import Mousetrap from 'mousetrap'
import 'mousetrap-global-bind'

export default {
    bind(shortcut) {
        if (shortcut.callback) {
            Mousetrap.bindGlobal(shortcut.combination, shortcut.callback)
        }

        Store.dispatch('shortcuts/addOne', {
            description: shortcut.description,
            combination: shortcut.combination,
        })
    },

    unbindAll() {
        const shortcuts = Store.getters['shortcuts/getList']
        shortcuts.forEach((shortcut) => Mousetrap.unbind(shortcut.combination))
        Store.dispatch('shortcuts/clearList')
    },
}
